// Lightweight browser logger for the simulator SPA. Enabled automatically in development; in a
// production build, set REACT_APP_DEBUG=true to turn it on (so we don't spam end-user consoles by
// default). The browser never holds tokens (cookie-session), so there's nothing secret to leak here;
// we still avoid dumping full response bodies that may carry PII.

const ENABLED =
  process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DEBUG === 'true';

const stamp = () => new Date().toISOString().slice(11, 23); // HH:MM:SS.mmm

export default function makeLogger(scope) {
  const tag = `[sim:${scope}]`;
  return {
    debug: (...args) => { if (ENABLED) console.debug(stamp(), tag, ...args); },
    info: (...args) => { if (ENABLED) console.log(stamp(), tag, ...args); },
    warn: (...args) => { if (ENABLED) console.warn(stamp(), tag, ...args); },
    // Errors always surface, even in a non-debug production build.
    error: (...args) => { console.error(stamp(), tag, ...args); }
  };
}
